import * as React from "react";
function SvgVideoCircleBg(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <circle cx={12.5} cy={12.5} r={12.5} fill="#fff" />
      <path
        d="M9.344 9.188v6.624c0 .521.229.907.687 1.157.458.25.906.23 1.344-.062l5.126-3.313c.416-.271.624-.636.624-1.094 0-.458-.208-.822-.624-1.094l-5.126-3.313c-.438-.291-.886-.312-1.344-.062-.458.25-.687.636-.687 1.157zM12.5 25c-1.73 0-3.354-.328-4.875-.984a12.62 12.62 0 01-3.97-2.672 12.618 12.618 0 01-2.671-3.969C.328 15.855 0 14.23 0 12.5c0-1.73.328-3.354.984-4.875a12.618 12.618 0 012.672-3.97A12.618 12.618 0 017.625.985C9.145.328 10.77 0 12.5 0c1.73 0 3.354.328 4.875.984a12.618 12.618 0 013.97 2.672 12.62 12.62 0 012.671 3.969c.656 1.52.984 3.146.984 4.875 0 1.73-.328 3.354-.984 4.875a12.62 12.62 0 01-2.672 3.97 12.62 12.62 0 01-3.969 2.671c-1.52.656-3.146.984-4.875.984zm0-2.625c2.73 0 5.057-.964 6.984-2.89 1.927-1.928 2.89-4.256 2.89-6.985 0-2.73-.963-5.057-2.89-6.984-1.927-1.927-4.255-2.89-6.984-2.89-2.73 0-5.057.963-6.984 2.89-1.927 1.927-2.89 4.255-2.89 6.984 0 2.73.963 5.057 2.89 6.984 1.927 1.927 4.255 2.89 6.984 2.89z"
        fill="#999"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVideoCircleBg);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
